import { Injectable } from '@angular/core';
import { Parada } from '@tivic-team/manager-ts/dist/mob/entities/parada/parada.entity';
import { ParadaController } from 'app/controllers/mob/parada.controller';
import { ParadaColetivoRuralDTO } from 'app/model/dtos/mob/parada-coletivo-rural.dto';
import { ParadaColetivoUrbanoDTO } from 'app/model/dtos/mob/parada-coletivo-urbano.dto';
import { ParadaDTO } from '../../model/dtos/mob/parada.dto';
import { LoaderService } from '../loader.service';
import { ParadaSearch } from './parada.search';


@Injectable()
export class ParadaService{

    constructor(
        private _paradaController: ParadaController,
        private _loaderService: LoaderService
    ){}

    async getByGrupo(cdGrupoParada: number):Promise<Parada[]>{
        this._loaderService.show();
        return this._paradaController.getByGrupo(cdGrupoParada).finally(() => this._loaderService.hide());
    }

    async find(search: ParadaSearch):Promise<ParadaColetivoUrbanoDTO[]>{
        this._loaderService.show();
        return this._paradaController.find(search && search.getFilters() || null).finally(() => this._loaderService.hide());
    }

    async findColetivoRural(search: ParadaSearch):Promise<ParadaColetivoRuralDTO[]>{
        this._loaderService.show();
        return this._paradaController.findColetivoRural(search && search.getFilters() || null).finally(() => this._loaderService.hide());
    }

    async findTaxis(paradaSerach: ParadaSearch):Promise<Parada[]>{
        this._loaderService.show();
        try {
            return await this._paradaController.findTaxis(paradaSerach && paradaSerach.getFilters() || null).finally(() => this._loaderService.hide());
        }
        catch (error) { 
            return null; 
        }
    }
    
    async getTaxis(cdParada: number): Promise<ParadaDTO> {
        this._loaderService.show();
        return this._paradaController.getTaxis(cdParada).finally(() => this._loaderService.hide());
    }

    async get(cdParada: number): Promise<ParadaDTO> {
        this._loaderService.show();
        return this._paradaController.get(cdParada).finally(() => this._loaderService.hide());
    }

    async remove(cdParada: number): Promise<Parada> {
        this._loaderService.show();
        return this._paradaController.remove(cdParada).finally(() => this._loaderService.hide());
    }

}